module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyBAMAAADsEZWCAAAAIVBMVEVHcEwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAt9G3DAAAACnRSTlMA1AnAG6lT8ns2kbaxFAAAALpJREFUOMtjYKA/yFq1DLsE26q0VQnYtSxhcMeqiW25AwNLFTZNWSVAApsmkBYGNE3TEuBaYJo4O0Ekx6qFE2BaoJpYolYFANmzxLpWwLVANGUtTQYKMUQ5cEqZwLSANTkDvbUQJKMANDCqBG6t+4pVQQwQGQcGhelwLSBNZQwMTFAZBoYWJLd6KCDLoINRmSEtY4U1+S8H4i5jbGApUEZ1FTZgAtKohA3QM69HYXUbKJc0CmIDYgwDDwCfDmcNSqVK4gAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/images/about/expre3.png
// module id = PjN4
// module chunks = 0